export interface ITaskDocument {
    $type: string;
    Id: string;
    ImportTrackingId: string;
    Company: {
        Name: string
    }
    WrappedDocumentType: string
}